<template>
    <div v-if="model.htmlBody" v-html="model.htmlBody" v-epi-edit="'HtmlBody'" />
</template>

<script>

export default {
    props: ['model'],
};
</script>
